import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// PWA — register service worker
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then(() => {
        // Tell SW the API base so background sync can post to the right URL
        const send = () => {
          const active = navigator.serviceWorker.controller;
          active?.postMessage({ type: "SET_API_BASE", url: process.env.REACT_APP_BACKEND_URL + "/api" });
        };
        send();
        navigator.serviceWorker.addEventListener("controllerchange", send);
      })
      .catch(() => {});

    // Listen for SW telling us the queue drained → refresh app
    navigator.serviceWorker.addEventListener("message", (e) => {
      if (e.data?.type === "SYNC_DONE") {
        window.dispatchEvent(new CustomEvent("nafe-sync-done"));
      }
    });
  });
}
